import React from 'react';
import {addItem as yAddItem, getAllItems} from '../../../../../components/prosemirror-editor/yMaps/sourcePackageYMap';
import useYDocStore from '../../../../../stores/useYDocStore';

export default function useSnippetDropConfig(reportId) {
    const computeLocalIdFromSnippet = React.useCallback((snippet) => {
        if (!snippet) return null;
        if (snippet.localId) return snippet.localId;

        const start = snippet.start || {};
        const end = snippet.end || {};

        const startIndex = (start.segmentIndex != null ? start.segmentIndex : snippet.index);
        const startOffset = (start.segmentOffset != null ? start.segmentOffset : (snippet.offset ?? 0));
        const endIndex = (end.segmentIndex != null ? end.segmentIndex : startIndex);
        const endOffset = (end.segmentOffset != null ? end.segmentOffset : startOffset);

        if (snippet.docId != null && startIndex != null && startOffset != null && endIndex != null && endOffset != null) {
            return [snippet.docId, startIndex, startOffset, endIndex, endOffset].join(':');
        }

        return null;
    }, []);

    const addToSourcePackage = React.useCallback((snippet) => {
        const localId = computeLocalIdFromSnippet(snippet);
        if (!localId) return;

        const {ydoc, ySourcePackage} = useYDocStore.getState();
        if (!ydoc || !ySourcePackage) return;

        const exists = getAllItems(ySourcePackage).some((item) => item?.localId === localId);
        if (!exists) {
            yAddItem(ydoc, ySourcePackage, {type: 'snippet', parentFolderId: null, localId, ...snippet});
        }
    }, [computeLocalIdFromSnippet]);

    const handleReferenceAdded = React.useCallback(() => {
        // Dropping references no longer adjusts URL params.
    }, []);

    return React.useMemo(() => ({
        reportId,
        onReferenceAdded: handleReferenceAdded,
        addToSourcePackage,
    }), [reportId, handleReferenceAdded, addToSourcePackage]);
}

